const lkLifeExpectancy = {
    name: 'lkLifeExpectancy',
    src: 'https://data.worldbank.org/indicator/SP.DYN.LE00.IN?locations=LK',
    content: {
        index: "ano",
        values: ['ano', 'idade'],
        keys: ['idade'],
        data: [
            {
                "ano": "1980",
                "idade": 68.171,
            },
            {
                "ano": "1990",
                "idade": 69.509,
            },
            {
                "ano": "2000",
                "idade": 71.333,
            },
            {
                "ano": "2015",
                "idade": 76.316,
            },
            {
                "ano": "2016",
                "idade": 76.482,
            },
            {
                "ano": "2017",
                "idade": 76.648,
            },
            {
                "ano": "2018",
                "idade": 76.812,
            },
        ]
    }
}

const lkRabbies = {
    name: 'lkRabbies',
    src: 'http://www.epid.gov.lk/web/images/pdf/wer/2017/vol_44_no_09-english.pdf',
    content: {
        index: "ano",
        values: ['ano', 'casos de raiva'],
        keys: ['casos de raiva'],
        data: [
            {
                "ano": "2010",
                "casos de raiva": 58,
            },
            {
                "ano": "2011",
                "casos de raiva": 50,
            },
            {
                "ano": "2012",
                "casos de raiva": 41,
            },
            {
                "ano": "2013",
                "casos de raiva": 38,
            },
            {
                "ano": "2014",
                "casos de raiva": 25,
            },
            {
                "ano": "2015",
                "casos de raiva": 26,
            },
            {
                "ano": "2016",
                "casos de raiva": 20,
            },
        ]
    }
}

const lkReligion = {
    name: 'lkReligion',
    src: 'https://www.indexmundi.com/sri_lanka/demographics_profile.html',
    content: [
        {
            "id": "Buddhist",
            "label": "Buddhist",
            "value": 70.2,
            "color": "hsl(325, 70%, 50%)"
        },
        {
            "id": "Hindu",
            "label": "Hindu",
            "value": 12.6,
            "color": "hsl(1, 70%, 50%)"
        },
        {
            "id": "Muslim",
            "label": "Muslim",
            "value": 9.7,
            "color": "hsl(169, 70%, 50%)"
        },
        {
            "id": "Roman Catholic",
            "label": "Roman Catholic",
            "value": 6.1,
            "color": "hsl(32, 70%, 50%)"
        },
        {
            "id": "other Christian",
            "label": "erlang",
            "value": 1.3,
            "color": "hsl(265, 70%, 50%)"
        },
        {
            "id": "other",
            "label": "other",
            "value": 0.05,
            "color": "hsl(265, 70%, 50%)"
        },
    ]
}

const lkEtnicity = {
    name: 'lkEtnicity',
    src: 'https://www.indexmundi.com/sri_lanka/demographics_profile.html',
    content: [
        {
            "id": "Sinhalese",
            "label": "Sinhalese",
            "value": 74.9,
            "color": "hsl(325, 70%, 50%)"
        },
        {
            "id": "Sri Lankan Tamil",
            "label": "Sri Lankan Tamil",
            "value": 11.2,
            "color": "hsl(1, 70%, 50%)"
        },
        {
            "id": "Sri Lankan Moors",
            "label": "Sri Lankan Moors",
            "value": 9.2,
            "color": "hsl(169, 70%, 50%)"
        },
        {
            "id": "Indian Tamil",
            "label": "Indian Tamil",
            "value": 4.2,
            "color": "hsl(32, 70%, 50%)"
        },
        {
            "id": "other",
            "label": "other",
            "value": 0.5,
            "color": "hsl(265, 70%, 50%)"
        }
    ]
}

const lkWomenTravel = {
    name: 'lkWomenTravel',
    src: 'https://solotravelerworld.com/wp-content/uploads/2018/12/Solo-Travel-Trends-Report_Full_v3.pdf',
    content: [
        {
            "id": "Mulheres",
            "label": "Mulheres",
            "value": 85.7,
            "color": "hsl(325, 70%, 50%)"
        },
        {
            "id": "Homens",
            "label": "Homens",
            "value": 13.7,
            "color": "hsl(1, 70%, 50%)"
        },
        {
            "id": "Desconhecido",
            "label": "Prefere não dizer",
            "value": 0.6,
            "color": "hsl(169, 70%, 50%)"
        }
    ],
}

export {
    lkLifeExpectancy,
    lkRabbies,
    lkReligion,
    lkEtnicity,
    lkWomenTravel
}